<template>
    <b-datatable
        :key="dataTableKey"
        :columns="columns"
        :endpoint="listRoute"
        :hidden-columns="['id']"
        :meta-fields="metaFields"
        has-filter-selector
        item-key="id"
    >
        <template #filters="{ filters }">
            <v-col cols="4">
                <v-text-field
                    v-model="filters.filters.name"
                    :label="t('languages::label.name')"
                    class="flex-grow-0"
                    clearable
                    dense
                    outlined
                    tabindex="1"
                    rounded
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="filters.filters.code"
                    :label="t('languages::label.code')"
                    class="flex-grow-0"
                    clearable
                    dense
                    rounded
                    outlined
                    tabindex="1"
                ></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="filters.filters.culture"
                    :label="t('languages::label.culture')"
                    class="flex-grow-0"
                    clearable
                    dense
                    rounded
                    outlined
                    tabindex="1"
                ></v-text-field>
            </v-col>
        </template>
        <template #[`item.code`]="{ item }">
            <div class="grid-status">
                <span>
                    {{ item.code }}
                </span>
            </div>
        </template>
        <template #[`item.culture`]="{ item }">
            <i class=""> {{ item.culture }} </i>
        </template>
        <template #[`item.is_active`]="{ item }">
            <div class="grid-status">
                <span>
                    {{ item.is_active ? t('default::status.active') : t('default::status.inactive') }}
                </span>
            </div>
        </template>
        <template #[`item.is_default`]="{ item }">
            <div class="grid-status">
                <span>
                    {{ item.is_default ? t('default::status.default') : t('default::status.not_default') }}
                </span>
            </div>
        </template>
        <template #[`item.actions`]="{ item }">
            <div class="table-actions">
                <v-btn v-if="can('translations.index')" :href="getTranslationsUrl(item)" color="disabled-color">
                    <v-icon left small>mdi-format-list-checks</v-icon>
                    {{ t('default::button.translate') }}
                </v-btn>
                <v-btn v-if="can('languages.get')" :href="getItemUrl(item)" color="disabled-color">
                    <v-icon left small>mdi-pencil</v-icon>
                    {{ t('default::button.edit') }}
                </v-btn>
            </div>
        </template>
        <template #[`body.append`]="data">
            <th class="empty" colspan="3"></th>
            <th :class="data.tdTotalsClass">
                {{ t('languages::table.meta.active_total') }} : {{ data.metaData.active_languages_count }}
            </th>
            <th :class="data.tdTotalsClass">
                {{ t('languages::table.meta.grand_total') }} : {{ data.metaData.total_languages_count }}
            </th>
            <th class="empty" colspan="1"></th>
        </template>

        <template #buttons>
            <v-btn v-if="can('languages.create')" :href="getCreateUrl()" color="success">
                <v-icon left small>mdi-plus</v-icon>
                {{ t('default::button.create.new') }}
            </v-btn>
        </template>
    </b-datatable>
</template>

<script>
export default {
    name: 'LanguagesList',
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            metaFields: ['total_languages_count', 'active_languages_count'],
            columns: [
                {
                    text: t('languages::grid.label.id'),
                    value: 'id',
                    sortable: false,
                    width: 170,
                },
                {
                    text: t('languages::grid.label.name'),
                    value: 'name',
                    width: 200,
                    sortable: true,
                },
                {
                    text: t('languages::grid.label.code'),
                    value: 'code',
                    width: 100,
                    sortable: true,
                },
                {
                    text: t('languages::grid.label.culture'),
                    value: 'culture',
                    width: 100,
                    sortable: true,
                },
                {
                    text: t('languages::grid.label.is_active'),
                    value: 'is_active',
                    width: 100,
                    sortable: true,
                },
                {
                    text: t('languages::grid.label.is_default'),
                    value: 'is_default',
                    width: 100,
                    sortable: true,
                },
                {
                    text: t('languages::grid.label.actions'),
                    value: 'actions',
                    sortable: false,
                    fields: null,
                    width: 100,
                    align: 'end',
                },
            ],
            dataTableKey: 0,
        };
    },
    methods: {
        getCreateUrl() {
            return route('languages.create');
        },
        getItemUrl(item) {
            return route('languages.get', { language: item.id });
        },
        getTranslationsUrl(item) {
            return route('translations.index', { language: item.code });
        },
    },
};
</script>
